import { useState, useTransition, Suspense } from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { DashboardNavbar } from "./dashboard-navbar";
import { DashboardSidebar } from "./dashboard-sidebar";
import { Box, LinearProgress } from "@mui/material";
import RoutePreloader from "../RoutePreloader";

const DashboardLayoutRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  maxWidth: "100%",
  overflow: "hidden",
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 240,
  },
}));

const ContentContainer = styled("div")(({ theme }) => ({
  flex: "1 1 auto",
  width: 0, // force le flex child à respecter la largeur du parent
  minWidth: 0,
  paddingTop: 64,
  overflowX: "hidden",
  backgroundColor: theme.palette.background.default || "#F9FAFC",
  [theme.breakpoints.down("md")]: {
    paddingLeft: 0,
  },
}));

export const DashboardLayout = (props) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [openSide, setOpenSide] = useState(false);

  // useTransition remonté ici pour que isPending soit accessible
  // à la fois dans la sidebar (barre de progression) ET dans la zone de contenu
  // (overlay), résolvant le bug "page ne s'affiche pas après refresh + navigation".
  const [isPending, startTransition] = useTransition();

  return (
    <DashboardLayoutRoot>
      {/* Précharge tous les chunks de route en arrière-plan après le login */}
      <RoutePreloader />
      <DashboardSidebar
        onClose={() => setIsSidebarOpen(false)}
        open={isSidebarOpen}
        openSide={openSide}
        setOpenSide={setOpenSide}
        isPending={isPending}
        startTransition={startTransition}
      />
      <ContentContainer>
        {/* Barre de chargement en haut de la zone de contenu pendant la navigation */}
        {isPending && (
          <LinearProgress
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1300,
              height: "3px",
            }}
          />
        )}
        {/* Opacité réduite pendant la transition pour signaler le changement de page */}
        <Suspense fallback={null}>
          <Box sx={{ opacity: isPending ? 0.5 : 1, transition: "opacity 0.25s ease" }}>
            <Outlet />
          </Box>
        </Suspense>
      </ContentContainer>
      <DashboardNavbar
        onOpenSidebar={() => setOpenSide(true)}
        open={isSidebarOpen}
        openSide={openSide}
        setOpenSide={setOpenSide}
      />
    </DashboardLayoutRoot>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
